import {AutoRefreshButton} from "@/components/autoRefreshButton/AutoRefreshButton.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DatePicker} from "@/components/datePicker/DatePicker.tsx";
import {RequiredDateRange} from "@/components/datetime/utils.ts";
import {ToggleFullscreenButton} from "@/components/toggleFullscreenButton/ToggleFullscreenButton.tsx";
import {StandardDateRange} from "@/lib/queries/reports.ts";
import {RUMAggregationSelect} from "@/pages/rum/v2/details/RUMAggregationSelect.tsx";
import {RUMURLGroupHashSearch, RUMURLSearch} from "@/pages/rum/v2/details/RUMURLSearch.tsx";
import {RUMAggregationType} from "@/pages/rum/v2/types.ts";

interface RUMCheckActionBarProps {
  agg: RUMAggregationType;
  id: number;
  start?: Date;
  end?: Date;
  fixedRange?: StandardDateRange;
  onRangeChange: (range: RequiredDateRange | null, fixedRange?: StandardDateRange | null) => void;
  setAgg: (agg: RUMAggregationType) => void;
  refreshSeconds: number | undefined;
  setRefresh: (seconds?: number) => void;
  onURLChange: (url: RUMURLSearch | null) => void;
}
export const RUMCheckActionBar = ({
  id,
  agg,
  setAgg,
  refreshSeconds,
  setRefresh,
  onURLChange,
  start,
  end,
  fixedRange,
  onRangeChange,
}: RUMCheckActionBarProps) => {
  const {user} = useCurrentUserContext();
  return (
    <div className="d-flex align-items-center gap-2">
      <RUMURLGroupHashSearch urlId={id} onChange={onURLChange} start={start} end={end} />
      <DatePicker
        mode={"range"}
        selected={{
          from: start,
          to: end,
        }}
        timezone={user!.account!.timezone}
        dateFormat={user!.current_date_format}
        fixedRange={fixedRange}
        placement={"bottom-end"}
        onChange={(date, fixedRange) => {
          const newDateRange = !date?.from || !date?.to ? null : (date as RequiredDateRange);
          onRangeChange(newDateRange, fixedRange);
        }}
        disableFutureDates
        hasPopoverInput
      />
      <RUMAggregationSelect
        value={{value: agg}}
        onChange={(value) => setAgg(value ? value.value : RUMAggregationType.MED)}
      />
      <AutoRefreshButton seconds={refreshSeconds} setSeconds={setRefresh} />
      <ToggleFullscreenButton />
    </div>
  );
};
